import { notifyError } from '@/bugsnag';
import { memoizedHasTouchScreen, setMemoizedTouchScreenState } from '@/shared/utils/touchScreenState';

export const isTouchScreenDevice = () => {
    if (memoizedHasTouchScreen !== null) {
        return memoizedHasTouchScreen;
    }

    let hasTouchScreen = false;
    if ('maxTouchPoints' in navigator) {
        hasTouchScreen = navigator?.maxTouchPoints > 0;
    } else {
        const mQ = matchMedia?.('(pointer:coarse)');
        if (mQ?.media === '(pointer:coarse)') {
            hasTouchScreen = !!mQ.matches;
        } else if ('orientation' in window) {
            hasTouchScreen = true; // deprecated, but good fallback
        } else {
            // Only as a last resort, fall back to user agent sniffing
            // this navigator as Navigator hack is a workaround for a typescript error
            // not seeing the userAgent property on navigator.
            const UA: string = (navigator as Navigator)?.userAgent;
            hasTouchScreen =
                /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
        }
    }
    setMemoizedTouchScreenState(hasTouchScreen);
    return hasTouchScreen;
};

export const attachBroadcastChannelListener = (
    channelName: string,
    channelEventListener: NonNullable<BroadcastChannel['onmessage']>,
): BroadcastChannel | void => {
    if (!('BroadcastChannel' in window)) return;

    const channel = new BroadcastChannel(channelName);
    channel.addEventListener('message', channelEventListener);
    return channel;
};

export const scrollToElement = (targetElement: HTMLElement | null) => {
    targetElement?.scrollIntoView({ behavior: 'smooth' });
};

export const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const print = () => {
    try {
        window.print();
    } catch (error) {
        notifyError(error, 'browser:print');
    }
};
